export default function ({ $axios, redirect, store, route }) {
  $axios.get('sanctum/csrf-cookie')
  .then((response) => {
    $axios.get('api/get-user')
    .then((response) => {
      store.dispatch('setUser', response.data.user)
    })
    .catch((error) => {
      store.dispatch('setUser', {})
      console.log(error)
      if (route.path !== '/login/' && route.path !== '/reset-password/' && route.path !== '/reset-email/') {
        redirect('/login/')
      }
    })
  })
}